<template>
	<div
		:class="[
			inside
				? settings.spacings.padding[spacing]
				: settings.spacings.margin[spacing],
		]"
	>
		<slot />
	</div>
</template>

<script setup>
import {defineSettings} from '../composables/component';

const settings = defineSettings('NkWrapper');

defineProps({
	spacing: {
		type: String,
		default: 'default',
		required: false,
	},
	inside: {
		type: Boolean,
		default: false,
		required: false,
	},
});
</script>
